import { TEST, TEST_TAB_KEYS } from "../actions/types";
import { TASK_TYPES } from "../actions/constants";
import { getQuestion, getRandomID, isValidURL } from "../utills/common";

const initialState = {
  error: null,
  draft_id: null,
  isSaving: false,
  isLoading: true,
  activeTaskIds: [],
  showErrors: false,
  showScreener: false,
  openTaskSettings: false,
  openLogic: false,
  showTaskTypeSelection: false,
  defaults: {},
  countries: [],
  data: { test: {}, tasks: [], settings: {} },
  data_launched: { test: {}, tasks: [], settings: {} },
  prototypes: [],
  previousPresentedNodeId: null,
  screener: {},
  figmaGuideToShowStep: 1,
  published: false,
  activeTabKey: TEST_TAB_KEYS.CREATE,
  isAuthor: false,
  enableTaskScroll: false,
  updateConfirmationModal: {
    show: false,
    errorMessage: {},
    onCancel: () => {},
    onProceed: () => {},
    confirmationFor: TEST.CONFIRMATION_FOR.TASK_LOGIC,
  },
  isSlackIntegrated: false,
  isWelcomeGreetingActive: false,
  isThankyouGreetingActive: false,
  showTaskTypeSelectorInDetails: false,
  showTaskImagesUploadModal: false,
};

const screenerInitialState = {
  id: null,
  error: null,
  data: { activeID: "", questions: [], published: false },
  data_launched: { activeID: "", questions: [], published: false },
};

const getInitialScreenerData = (screenerPayload) => {
  if (!screenerPayload) {
    const question = getQuestion();
    return { ...screenerInitialState, data: { ...screenerInitialState.data, activeID: question.id, questions: [question] } };
  }

  const { data } = screenerPayload;
  if (data.questions.length > 0) return screenerPayload;

  const question = getQuestion();
  return { ...screenerPayload, data: { ...data, activeID: question.id, questions: [question] } };
};

const testReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TEST.LOAD:
      return {
        ...initialState,
        isLoading: false,
        countries: state.countries,
        activeTaskIds: state.activeTaskIds,
        openTaskSettings: state.openTaskSettings,
        openLogic: state.openLogic,
        ...payload,
        screener: getInitialScreenerData(payload.screener),
        figmaGuideToShowStep: state.figmaGuideToShowStep,
        published: payload.data.published || false,
        updateConfirmationModal: state.updateConfirmationModal,
      };

    case TEST.UPDATE:
      if (payload?.data?.tasks) {
        payload.data.tasks = payload.data.tasks.map((task, position, arr) => {
          const { url = "", use_prevtask_url = false } = task;

          return {
            ...task,
            position,
            url:
              use_prevtask_url && (url === "" || !isValidURL(url))
                ? arr.find((t) => Number(t.type) === TASK_TYPES.DEFAULT || Number(t.type) === TASK_TYPES.EXTERNAL_PROTOTYPE)?.url || ""
                : url,
            use_prevtask_url: use_prevtask_url
              ? arr
                  .slice(0, position)
                  ?.some((t) => Number(t?.type) === TASK_TYPES.DEFAULT || Number(t?.type) === TASK_TYPES.EXTERNAL_PROTOTYPE)
              : false,
          };
        });
      }

      return { ...state, isLoading: false, ...payload };

    case TEST.RESET:
      return initialState;

    case TEST.SHOW_UPDATE_CONFIRMATION_MODAL:
      return { ...state, updateConfirmationModal: { ...action.payload } };

    case TEST.ADD_SCREENER_QUESTION: {
      const { data } = state.screener;
      const { questions } = data;

      const newquestions = [...questions];
      const newquestion = getQuestion(payload);
      newquestions.splice(payload, 0, newquestion);
      return {
        ...state,
        screener: {
          ...state.screener,
          data: { ...data, activeID: newquestion.id, questions: newquestions.map((q, position) => ({ ...q, position })) },
        },
      };
    }

    case TEST.DUPLICATE_SCREENER_QUESTION: {
      const { data } = state.screener;
      const { questions } = data;
      let question = getQuestion(questions.length);

      let quest = questions.find((q) => q.id === payload);
      question.title = quest.title;
      question.category = quest.category;
      question.options = quest.options.map((o) => ({ ...o, id: getRandomID(), oldId: o.id }));
      question.answers = createNewAnswerTree(quest, question);

      // const getAnswerObjLocal = (answerId) => {
      //   const answerOpt = question.options.find((opt) => opt.oldId === answerId);
      //   return getAnswerObj(answerOpt ? answerOpt.id : "");
      // };

      // // Copy Answers

      // const { answers } = quest;
      // if (answers.op === OP_EQUALS && answers.var[0].value !== "") question.answers = getAnswerObjLocal(answers.var[0].value);
      // else if (answers.op === OP_OR)
      //   question.answers = { ...answers, var: answers.var.map((v) => getAnswerObjLocal(v?.var[0]?.value)) };

      function createNewAnswerTree(originalQuestion, duplicateQuestion) {
        // Create a mapping of old option IDs to new option IDs
        const idMapping = {};
        duplicateQuestion.options.forEach((option) => {
          idMapping[option.oldId] = option.id;
        });

        // Helper function to recursively update option IDs in the answer tree
        function updateAnswerTree(node) {
          if (node.var) {
            node.var = node.var.map((subNode) => updateAnswerTree(subNode));
          }
          if (node.type === "option" && idMapping[node.value]) {
            return { ...node, value: idMapping[node.value] };
          }
          return node;
        }

        // Copy and update the answer tree
        const newAnswerTree = updateAnswerTree(JSON.parse(JSON.stringify(originalQuestion.answers)));
        return newAnswerTree;
      }

      return {
        ...state,
        screener: { ...state.screener, data: { ...data, activeID: question.id, questions: [...questions, question] } },
      };
    }

    case TEST.UPDATE_SCREENER: {
      return { ...state, screener: { ...state.screener, ...payload } };
    }

    default:
      return state;
  }
};

export default testReducer;
